import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  ListItem,
  OrderedList,
  Text,
  UnorderedList,
  Link,
} from '@chakra-ui/react';
import { FaLinkedin, FaTwitter } from 'react-icons/fa';
import BlogTableComponent from '@/components/blog/BlogTableComponent';

const IndividualBlog: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="300px"
      minH="300px"
      maxH="300px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        // eslint-disable-next-line no-constant-condition
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '32px', sm: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus : 8X Ventures A DeepTech Venture Capital Firm
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Chirag Gupta, Managing Partner, 8X Ventures
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. Today we speak to Chirag Gupta, Managing
          Partner,{' '}
          <Flex
            display="inline-flex"
            alignItems="center"
            _hover={{ textDecoration: 'underline' }}
            cursor="pointer"
          >
            <Text variant="blogAnswer" textDecor="underline">
              <a
                href="https://www.8xventures.co"
                target="_blank"
                rel="noreferrer"
              >
                8X Ventures&nbsp;
              </a>
            </Text>
          </Flex>
          &nbsp;to learn more about the firm and his vision for the fund.
        </Text>
      </Box>

      <Img
        src="/webp/chirag.webp"
        alt="chirag_gupta"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '70px' }}
        mb="20px"
        objectFit="cover"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson : Chirag Gupta, Managing Partner, 8X Venture
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="center">
              <Link
                href="https://www.linkedin.com/in/chirag-gupta/"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
            <Box alignSelf="center">
              <Link href="https://twitter.com/CommittedChirag" target="_blank">
                <IconButton
                  aria-label="twitter"
                  icon={
                    <FaTwitter size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />

        {/* Question 1 */}
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. What makes 8X Ventures a DeepTech VC? Tell us more about the
            firm&apos;s ethos, investment strategy, and focus areas.
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            We are on a mission to invest and enable startups that will lead
            disruptive innovation and create sustainable value for industries
            and economies. The intent is to enable entrepreneurs to solve large
            and fundamental issues by operating at the convergence of
            technologies such as Artificial intelligence, Big data, 3D printing,
            Robotics, and the Internet of Things.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            We have partnered with top educational and research institutions
            like IITs, IISc, and other leading engineering institutions in India
            and worldwide. We work closely with the DeepTech enablers such as
            NASSCOM, NITI Aayog, IVCA, Hello Tomorrow, and numerous incubators,
            accelerators, and research parks to ensure we spot the winners in
            the DeepTech ecosystem.
          </Text>
          <Heading variant="blogQuestion" pb="12px">
            Firm&apos;s ethos and investment strategy
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            As a fund, we are firmly rooted in the DeepTech ecosystem to
            identify, invest, and strategically grow our portfolio companies
            through our strong domain expertise, fast-growing track record and
            extensive network
          </Text>
          <Heading variant="blogQuestion" pb="12px">
            We invest in startups that
          </Heading>
          <OrderedList>
            <ListItem pb="14px">
              <Text variant="blogAnswer">
                Focus on &quot;global&quot; Proof of Value (not just
                &quot;local&quot; PoC) Building global companies from India.
              </Text>
            </ListItem>
            <ListItem pb="14px">
              <Text variant="blogAnswer">
                Strive for Sustainable Competitive Advantage (not just first
                mover advantage) We choose to invest in exponential gains rather
                than incremental improvements, i.e. we invest in DeepTech
                ventures that propose a ten times better product, not simply a
                10% improvement.
              </Text>
            </ListItem>
            <ListItem pb="14px">
              <Text variant="blogAnswer">
                A closer look at the founders and management team Several
                factors weigh in, such as relevant skills, startup experience,
                likeability, values and beliefs, network and focus.
              </Text>
            </ListItem>
          </OrderedList>
          <Heading variant="blogQuestion" pt="6px" pb="14px">
            Focus Areas
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Within DeepTech, our primary focus areas include Industry 4.0,
            CleanTech and BioTech. Apart from these, we explore other DeepTech
            investment startups opportunistically.
          </Text>
          <Text variant="blogAnswer">
            We are open to investing in startups across India, Singapore, MENA,
            and the European region. Our typical cheque size varies from $200K
            to $1Mn, and we do Seed to Series A investments.
          </Text>
        </Box>
        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. How do you spot &apos;winning&apos; enterprises and start-ups in
            the deep tech category?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Identifying winners in the DeepTech investing requires a nuanced
              approach vs sector-agnostic VC investing. We combine these three
              approaches to identify &quot;Winning DeepTech startups.&quot;
            </Text>
            <Heading variant="blogQuestion" pb="16px">
              A. Identify the maturity of the startup
            </Heading>
            <Box pl="20px">
              <Text variant="blogAnswer" pb="16px">
                Evaluating startups&apos; investability based on their technical
                maturity and market readiness
              </Text>
              <Text variant="blogAnswer" pb="8px">
                We bet on Potential Quick Wins with significant Proof of Value
              </Text>
              <UnorderedList>
                <ListItem>
                  <Text variant="blogAnswer" pb="8px">
                    The key tech components are either fully developed or will
                    be developed within &#060; 1 year
                  </Text>
                </ListItem>
                <ListItem>
                  <Text variant="blogAnswer" pb="8px">
                    The market (customer segment) is either ready to adopt or
                    will be ready within &#060; 1 year
                  </Text>
                </ListItem>
              </UnorderedList>
            </Box>
            <Heading variant="blogQuestion" py="16px">
              B. Identify the sustainable competitive advantage of the startup
            </Heading>
            <Text variant="blogAnswer" pb="6px" pl="20px">
              Three factors often define that:
            </Text>
            <Box pl="40px">
              <Text variant="blogAnswer" pb="8px">
                a. Does the startup integrate multiple technologies?
              </Text>
              <Text variant="blogAnswer" pb="8px">
                b. Does the startup solve a fundamental problem that can
                transform an industry (and potentially contribute to UN SDG
                goals)?
              </Text>
              <Text variant="blogAnswer" pb="8px">
                c. Is the startup embedded in the DeepTech ecosystem (i.e.
                universities, research labs, government, corporate R&D, et
                cetera.)
              </Text>
            </Box>
            <Heading variant="blogQuestion" py="16px">
              C. Identify the readiness of the startup to scale the DeepTech
              solution.
            </Heading>
            <Text variant="blogAnswer" pb="6px" pl="20px">
              Two dimensions contribute to the review:
            </Text>
            <Box pl="40px">
              <Text variant="blogAnswer" pb="8px">
                a. Review of Customers, Company, and Colleagues
              </Text>
              <Text variant="blogAnswer" pb="8px">
                b. Review of Industry, Strategy and Value Proposition
              </Text>
            </Box>
          </Box>
        </Box>

        {/* Question 3 */}

        <Box py="16px">
          <Heading variant="blogQuestion" pt="28px">
            3. Share the impact created by some of your portfolio companies in
            the frontier tech space.
          </Heading>
          <BlogTableComponent />
        </Box>

        {/* Question 4 */}
        <Box py="16px">
          <Heading variant="blogQuestion" pt="16px">
            4. What excites 8X Ventures about the &apos;India Opportunity&apos;
            in the growing digital economy?
          </Heading>
          <Box>
            <Text variant="blogAnswer" py="16px">
              The Indian DeepTech startup ecosystem is one of the
              fastest-growing industries in India. Five trends are driving this
              momentum
            </Text>
            <UnorderedList pl="20px">
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  <Heading as="span" variant="blogQuestion">
                    Investor trust & interest in DeepTech startups is on the
                    rise -
                  </Heading>
                  &nbsp;2.5X growth in DeepTech Investments in India in the last
                  year
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  <Heading as="span" variant="blogQuestion">
                    Indian Engineering and R&D are growing exponentially -
                  </Heading>
                  &nbsp;India&apos;s annual STEM graduates supply is ~ 2.14M.
                  India is among the top 10 R&D spenders in the world and has
                  close to 7000 R&D institutions in place
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  <Heading as="span" variant="blogQuestion">
                    Government Initiatives have started to show the on-ground
                    impact -
                  </Heading>
                  &nbsp;There are 500+ grants and schemes under which DeepTech
                  startups can raise money from the Indian government
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  <Heading as="span" variant="blogQuestion">
                    India&apos;s demography is shifting towards Al/loT-based
                    digital adoption -
                  </Heading>
                  &nbsp;According to a NASSCOM report, data and AI could add US$
                  450 – 500 billion to India&apos;s GDP by 2025, representing
                  ~10 per cent of India&apos;s US$ 5 trillion economy aspiration
                </Text>
              </ListItem>
              <ListItem>
                <Text variant="blogAnswer" pb="8px">
                  <Heading as="span" variant="blogQuestion">
                    Tech incubators and accelerators are growing; investors
                    prefer sector-specific accelerators -
                  </Heading>
                  &nbsp;With 520+ incubators and accelerators, India has the 3rd
                  largest number of active programs in the world.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            5. Deep tech will shape the future. Any advice for budding
            entrepreneurs who are keen to explore this area of work?
          </Heading>
          <UnorderedList pl="20px">
            <ListItem>
              <Text variant="blogAnswer" pb="8px">
                <Heading as="span" variant="blogQuestion">
                  Longer gestation period -
                </Heading>
                &nbsp;Advanced markets, especially the US and Europe, attract
                significant patient capital. Startup investing has been there
                for a while, and on contrary, startup investing in India is
                still nascent. A significant number of HNWIs and family offices
                aren&apos;t comfortable putting significant capital into
                startups. This number is even lower for deeptech startups,
                considering the longer gestation period.So, if you are looking
                for a quick win, then this is not the right place.
              </Text>
            </ListItem>
            <ListItem>
              <Text variant="blogAnswer" pb="8px">
                <Heading as="span" variant="blogQuestion">
                  • Focus on &quot;global&quot; Proof of Value (not just
                  &quot;local&quot; PoC) - -
                </Heading>
                &nbsp;Building global companies from India. The US has been
                known to build solutions for global problems. However, a lot of
                Indian and Asian problems are unique. Indian DeepTech startups
                can build massive DeepTech businesses while simultaneously
                striving to build global solutions
              </Text>
            </ListItem>
            <ListItem>
              <Text variant="blogAnswer" pb="8px">
                <Heading as="span" variant="blogQuestion">
                  Talk to your customers and investors -
                </Heading>
                &nbsp;- One member of your team, preferably one of the
                co-founders, has to be almost always in the market getting
                bruised, getting beaten up by the customers, potential
                customers, and potential investors. This will teach you almost
                everything you need to know to make yourself investable.
              </Text>
            </ListItem>
          </UnorderedList>
          <Text variant="blogAnswer" pt="8px">
            Deeptech talent is rare, and that is what differentiates them. A
            smart DeepTech talent is more powerful and influential than probably
            having a million dollars in your bank account
          </Text>
        </Box>
      </Box>
    </Container>
  </>
);

export default IndividualBlog;
